import UserManagement from '../Users/Users.svelte';
import AssessmentList from '../Assessments/AssessmentList.svelte';
import AssessmentView from '../Assessments/AssessmentView.svelte';
import AssessmentAddEdit from '../Assessments/CreateAssessment.svelte';
import AssessmentTypeList from '../Assessments/AssessmentTypeList.svelte';
import AssessmentTypeAddEdit from '../Assessments/AssessmentTypeAddEdit.svelte';
import SnippetManager from '../Snippets/SnippetManager.svelte';
import ManageFindings from '../Assessments/ManageFindings.svelte';

import TransformEdit from '../Transforms/TransformEdit.svelte';
import TransformList from '../Transforms/TransformList.svelte';

import TableDesigner from '../Findings/TableDesigner.svelte';
import TableList from '../Findings/TableList.svelte';

import  NessusReportGenerator from '../Nessus/NessusReportGenerator.svelte';

export const routes = {
    '/auth/users/:id?': UserManagement,
    '/assessments/': AssessmentList,
    '/assessment/:id?': AssessmentAddEdit,
    '/:type/view/:id': AssessmentView,
    '/assessmentTypes/': AssessmentTypeList,
    '/assessmentType/:id?': AssessmentTypeAddEdit,
    '/snippets/': SnippetManager,
    '/assessment/:assessment_id/findings/:finding_type': ManageFindings,

    '/transforms': TransformList,
    '/transforms/edit/:id?': TransformEdit,

    '/findings/templates/': TableList,
    '/findings/templates/table/:id?': TableDesigner,

    '/nessus/': NessusReportGenerator,
}